import { SolType } from "@/api";
import { useTypedSelector } from "@/store";

export function useUserSolType(): SolType {
  const useWrappedSol = useTypedSelector(
    (state) => state.profile.useWrappedSol,
  );
  return useWrappedSol ? "wsol" : "sol";
}
